import { styled } from '@mui/material';
import MuiSwitch from '@mui/material/Switch';

import { FormHelperText } from '@src/components/form';
import {
  FormControl,
  FormControlLabel,
  InputLabel,
} from '@src/components/form';

const IOSSwitch = styled((props) => (
  <MuiSwitch disableRipple focusVisibleClassName=".Mui-focusVisible" {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  marginRight: '8px',
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.red[200],
        opacity: 1,
        border: 0,
        ...theme.applyStyles('dark', {
          backgroundColor: '#2ECA45',
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      ...theme.applyStyles('dark', {
        color: theme.palette.grey[600],
      }),
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      ...theme.applyStyles('dark', {
        opacity: 0.3,
      }),
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    ...theme.applyStyles('dark', {
      backgroundColor: '#39393D',
    }),
  },
}));

export function Switch({ value, onTitle, offTitle, ...props }) {
  const status = value ? onTitle || 'Active' : offTitle || 'Inactive';
  return (
    <FormControlLabel
      label={status}
      sx={{ ml: 0 }}
      control={<IOSSwitch checked={value} {...props} />}
    />
  );
}
Switch.displayName = 'Switch';

export function SwitchField(props) {
  const { label, error, helperText, fullWidth, ...rest} = props;
  return (
    <FormControl fullWidth={fullWidth} error={error}>
      {label && <InputLabel>{label}</InputLabel>}
      <Switch {...rest} />

      <FormHelperText error={error} >
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}
SwitchField.displayName = 'SwitchField';
